export interface EmployeeHistory {
  dateModified: Date;
  i9Status: string;
  modifiedBy: string;
}
